import { z } from "zod/v4";

import {
  SubscriptionBillingProviderList,
  SubscriptionIntervalList,
} from "../../../dtos/subscriptions";

export const PostCustomBillingUrlRequestBodySchema = z.object({
  billingProvider: z.enum(SubscriptionBillingProviderList),
  interval: z.enum(SubscriptionIntervalList),
  intervalCount: z.number().optional(),
  customPrices: z.record(z.string(), z.number()),
  freeTrialLength: z.number(),
  test: z.boolean().optional(),
  email: z.email().optional(),
});

export type PostCustomBillingUrlRequestBodyType = z.infer<
  typeof PostCustomBillingUrlRequestBodySchema
>;

export const PostCustomBillingUrlResponseBodySchema = z.object({
  billingUrl: z.string(),
});

export type PostCustomBillingUrlResponseBodyType = z.infer<
  typeof PostCustomBillingUrlResponseBodySchema
>;
